import { deriveNormalisedBenchmarkPrice } from '../../fillsGraphData';
import { AnySelection, seriesSvgLine } from '@d3fc/d3fc-series';
import { deriveTime } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';
import { curveNatural } from 'd3-shape';

export const indexLine = seriesSvgLine()
    .crossValue(deriveTime)
    .mainValue(deriveNormalisedBenchmarkPrice)
    .curve(curveNatural)
    .decorate((s: AnySelection) => s.classed('indexLine', true));
